import { AimOutlined, CalendarOutlined, DollarOutlined } from '@ant-design/icons';
import type { ComponentType } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeStyledCardWrapper } from './AlertAndNotificationCard';

interface DecisionItem {
    icon: ComponentType<{ className?: string; style?: React.CSSProperties }>;
    title: string;
    color: string;
    path: string;
}

const items: DecisionItem[] = [
    {
        icon: AimOutlined,
        title: 'Annual Operating plan (AOP)',
        color: '270 65% 55%',
        path: '/ai-decision-hub/annual-operating-plan',
    },
    {
        icon: CalendarOutlined,
        title: 'Sales & Operations plan (S&OP)',
        color: '205 65% 52%',
        path: '',
    },
    {
        icon: DollarOutlined,
        title: 'Value tracker',
        color: '160 55% 48%',
        path: '',
    },
];

export const AIDecisionHub = () => {
    const navigate = useNavigate();

    return (
        <HomeStyledCardWrapper bordered={false} className="h-full">
            <div className="flex flex-col">
                <h3 className="text-lg font-semibold text-gray-800 mb-7 m-0">AI Decision Hub</h3>
                <div className="flex flex-col gap-7">
                    {items.map(({ icon: Icon, title, color, path }, index) => (
                        <div
                            key={index}
                            role="button"
                            aria-label={title}
                            onClick={() => path && navigate(path)}
                            className={`flex items-center gap-4 transition-opacity duration-200 ${
                                path ? 'cursor-pointer hover:opacity-80' : 'cursor-default'
                            }`}
                        >
                            <div
                                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl"
                                style={{ backgroundColor: `hsl(${color} / 0.12)` }}
                            >
                                <Icon className="text-xl" style={{ color: `hsl(${color})` }} />
                            </div>
                            <span className="font-medium text-sm text-foreground">{title}</span>
                        </div>
                    ))}
                </div>
            </div>
        </HomeStyledCardWrapper>
    );
};
